import type { PsychoeducationArticlePreview } from '@lighthouse/shared';
import { estimateArticleReadMinutes, formatArticleDate } from '@lighthouse/shared';

export { formatArticleDate };

export function estimateReadMinutes(article: PsychoeducationArticlePreview): number {
  return estimateArticleReadMinutes({
    summary: article.summary,
    expandParagraphs: article.expandParagraphs,
  });
}
